import { AssetPublishModel } from 'src/models/assetModel';
import { CollectionAssetModel } from "src/models/CollectionModel";
import { Skeleton } from "antd";
import { useState } from "react";
import { useEffect } from 'react';
import { ExtendedLicenseModel, StandardLicenseModel } from 'src/models/LicenseModel';
import { AssetType } from 'src/constant/assetConstants';
import { StandardLicense } from 'src/constant/licenseConstants';
import JustifiedGallery from '../gallerySearch/JustifiedGallery';

interface IProps {
  collectionAssetModel: CollectionAssetModel;
  isUseContainerImage?: boolean;
}

export default function GallerysCollection({
  collectionAssetModel,
}: IProps) {
  const [assets, setAssets] = useState<AssetPublishModel[]>([]);

  useEffect(() => {
    onSetAssetPublishModel();
  }, [collectionAssetModel]);

  const onSetAssetPublishModel = () => {
    const assetsInCollection: AssetPublishModel[] =
      collectionAssetModel.collectionItems
        .map<AssetPublishModel>((item) => ({
          id: item.asset.id,
          assetType: item.asset.assetType,
          code: item.asset.code!,
          name: item.asset.name,
          description: item.asset.description!,
          thumbnailImageUrl: item.asset.thumbnailImageUrl!,
          thumbnailVideoUrl: item.asset.thumbnailVideoUrl!,
          thumbnailVideoCoverUrl: item.asset.thumbnailVideoCoverUrl!,
          hasSMLicense: item.asset.hasSMLicense,
          hasXLLicense: item.asset.hasXLLicense,
          hasHDLicense: item.asset.hasHDLicense,
          hasUHDLicense: item.asset.hasUHDLicense,
          publishDate: new Date(),
          hasCollection: false,
          keywords: item.asset.keywords!,
          userId: '',
          artistFirstname: item.asset.artistFirstname,
          artistLastname: item.asset.artistLastname,
          artistNameEn: item.asset.artistNameEn,
          standardLicense: {
            id: 'string',
            assetType: AssetType.IMAGE,
            code: StandardLicense.SM,
            name: 'string',
            price: 0,
            sequence: 0,
          } as StandardLicenseModel,
          extendedLicense: {
            id: 'string',
            assetType: AssetType.IMAGE,
            code: StandardLicense.SM,
            name: 'string',
            price: 0,
            liftTimeType: 0,
            liftTime: 0,
            sequence: 0,
          } as ExtendedLicenseModel,
          price: 0,
          isDisabled: false,
          isHasLicense: false,
          imageOrientation: item.asset.imageOrientation ?? item.asset.orientation,
          orientation: item.asset.orientation,
          width: item.asset.width,
          height: item.asset.height,
        }));

    setAssets(assetsInCollection);
  };

  return collectionAssetModel.collectionItems.length > 0
    ? <JustifiedGallery assets={assets} />
    : <Skeleton.Image active />
}
